import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify'
import { Activity, currentRequestTimeStamp } from '../../../../../../Constants'
import { benchmarkUploadContainerName, Urls } from '../../../../../../Urls'
import mixpanel from 'mixpanel-browser'
import * as XLSX from 'xlsx'
import { getmillisec } from '../../../../../CompanyProfileNew/FreightMaster/FreightMaster/UploadExcel/Utility'
import { getCompanyFolderName, getUserFolderName } from '../../../../../../Utility'
import { readExcelFile } from "../../../../../CompanyProfileNew/FreightMaster/Utility/utility"
import axios from 'axios'
import Axios from '../../../../../../Axios'
import { getLocalDateTime, mailerAPI } from '../../../../Utility'
import { UserApiContext } from '../../../../../UserDetailsContext/UserDetailsContext'

const UploadFile = ({
    // step=0, 
    setStep = "",
    setExcel_details = '',
    allowedLanes,
}) => {
    const origin_index = [1, 3], destination_index = [4, 6], truck_type_index = 7, annual_volume = 10, transporter_rate_indexes = [11], transporter_name_indexes = [12]
    const [showerrors, setErrors] = useState([])
    const { userDetails, companyProfile } = useContext(UserApiContext);

    const emaillist = ['connect@logisticsnow.in', 'associate@logisticsnow.in']
    var cemail = (`${userDetails?.email}`)
    var cname = (`${userDetails?.email.substring(0, cemail.lastIndexOf("@"))}`);
    var dname = (`${userDetails?.email.substring(cemail.lastIndexOf("@") + 1)}`);
    const getEmailBody = (receivermail) => {
        // console.log('companyname', dname)
        // console.log('username', cname)
        let email_body = {
            from_email: "lorri@logisticsnow.in",
            user_type: 'transporter',
            subject: `LoRRI Benchmark - File upload alert`,
            activity: "Email Request",
            to_email: receivermail,
            content: `<p>Hello,</p><br/><p>Please find the details below :</p><br/>
                      <p>Company Name : ${dname}</p><br />
                      <p>User Name : ${cname}</p><br />
                      <p>User Email Id :  ${userDetails?.email}</p><br />
                      <p>Timestamp : ${getLocalDateTime(currentRequestTimeStamp())}</p><br />
                      <p>Warm Regards,<p>
                      <p>Team LoRRI</p>`,
            email_status: "Pending"
        }
        return email_body
    }

    const uploadandgetlocation = (file) => {
        return new Promise((resolve, reject) => {
            var ms = getmillisec()
            const ext = file['name'].split('.').pop()
            const fileName = file['name'].split('.')[0] + ms + '.' + ext
            let body = {
                'fileName': `company/${getCompanyFolderName(userDetails.email)}/${getUserFolderName(userDetails.email, companyProfile?.domain_data?.company_id)}/uncleaned_files/${userDetails?.user_id}-${fileName}`,
                'accountName': 'lnclientdata',
                'containerName': benchmarkUploadContainerName,
                'action': 'upload'
            }
            // console.log(file['fileData'])
            axios.post(Urls.fileService, body)
                .then(res => {
                    // console.log('inside post file upload')
                    // Call `PUT` request for uploading file to storage with url recieved from API
                    axios.put(res.data.url, file, {
                        headers: {
                            "x-ms-blob-type": "blockblob",
                            "x-ms-blob-content-disposition": file['type']
                        }
                    })
                        .then(r => {
                            resolve({
                                'status': 'success',
                            })
                            setTimeout(() => {
                                Axios.get(`${Urls.benchmarnow}?field=get_excel_logs`)
                                    .then(res => {
                                        // console.log(res.data)
                                        setExcel_details(res.data[0])
                                        setStep(2)
                                    }).catch(e => console.log(e))
                            }, 30000);
                            emaillist.map(item => mailerAPI(getEmailBody(item), '', '', ''))
                            // toast.success('Thank you for Uploading Your File. Someone from our team will get in touch with you shortly')
                        }).catch(error => {
                            toast.error('Error while uploading your attachments')
                            reject({
                                'status': 'failed',
                                'message': error
                            })
                        })
                })
                .catch(error => {
                    reject({
                        'status': 'failed',
                        'message': error
                    })
                    toast.error('Error while uploading your attachments')
                })
        })
    }

    const uploadAttachments = async (evt) => {
        setErrors([])
        Activity([{ "screen": "Upload Lanes", "module": "My Freight Benchmark", "user_activity": `User uploaded file`, "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`User has uploaded file`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',
            ModuleName: 'uploadLanes',
            ActivityLog: `userClickedUploadFileButton`,
            Data: evt.target.files.length > 0 ? evt.target.files[0] : {},
            Definition: `User has uploaded file`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
        if (evt.target.files.length > 0) {
            var file = evt.target.files[0]
            if (file['name'].split('.').pop() === 'xlsx') {
                const { data, headers, error } = await readExcelFile(file)
                if (error) {
                    toast.error(error)
                    return
                }
                const excelcount = data.length
                localStorage.setItem("excelcount", excelcount)

                let errors = []
                if (headers[origin_index[0]] === 'Origin Name*' &&
                    headers[origin_index[1]] === 'Origin State*' &&
                    headers[destination_index[0]] === 'Destination Name*' &&
                    headers[destination_index[1]] === 'Destination State*' &&
                    headers[truck_type_index] === 'Truck Type*' &&
                    headers[annual_volume] === 'Annual Volume*' &&
                    headers[transporter_rate_indexes[0]] === 'L1 Transporter Freight Rate*' &&
                    headers[transporter_name_indexes[0]] === 'L1 Transporter Name*') {

                    for (let i = 0; i < data.length; i++) {
                        if (!data[i]['Origin Name*']) {
                            errors.push(`Row ${i + 2}: Origin Name* cannot be empty`)
                        }
                        if (!data[i]['Origin State*']) {
                            errors.push(`Row ${i + 2}: Origin State* cannot be empty`)
                        }
                        if (!data[i]['Destination Name*']) {
                            errors.push(`Row ${i + 2}: Destination Name* cannot be empty`)
                        }
                        if (!data[i]['Destination State*']) {
                            errors.push(`Row ${i + 2}: Destination State* cannot be empty`)
                        }
                        // if(row_data[annual_volume] === ''){
                        //     errors.push(`Row ${i + 1}: ${header_data[annual_volume]} cannot be empty`)
                        // }
                        // if(row_data[transporter_rate_indexes[0]] === ''){
                        //     errors.push(`Row ${i + 1}: ${header_data[transporter_rate_indexes[0]]} cannot be empty`)
                        // }
                        // if(row_data[transporter_name_indexes[0]] === ''){
                        //     errors.push(`Row ${i + 1}: ${header_data[transporter_name_indexes[0]]} cannot be empty`)
                        // }
                        // for(var j = 0; j <= row_data.length; j++){
                        //     if((header_data[j] && header_data[j].includes('Transporter Freight Rate')) && (header_data[j+1] && header_data[j+1].includes('Transporter Name')) && (header_data[j+2] && header_data[j+2].includes('Transporter Share of business'))){
                        //         if((row_data[j] === '' && row_data[j+1] !== '') || (row_data[j] !== '' && row_data[j+1] === '')){
                        //             errors.push(`Row ${i+1}: ${header_data[j]} or ${header_data[j+1]} cannot be empty`)
                        //         }
                        //     }
                        // }
                        if (!data[i]['Truck Type*']) {
                            errors.push(`Row ${i + 2}: Truck Type* cannot be empty`)
                        }
                    }

                    if (excelcount > allowedLanes) {
                        if (window.confirm(`You have ${allowedLanes} credits and have uploaded ${excelcount} lanes. The benchmark for the first ${allowedLanes} lanes will now be displayed. Please click continue to proceed or call LoRRI to get more credits`)) {
                            setStep(1)
                        }
                    }
                    else if (errors.length > 0) {
                        evt.target.files[0].filename = 'error.xlsx'
                        document.getElementById('upload_file_button').files = evt.target.files
                        setErrors(errors)
                    } else {
                        setStep(1)
                        uploadandgetlocation(file)
                    }

                } else {
                    setErrors([...showerrors, 'Headers do not match to standard format, Please try again.'])
                }
            }
            else {
                toast.info('Please upload xlsx file')
            }
        }
    }

    // const DownloadExcelFormat = () => {
    //     return <table border="1" id="download_format" style={{display:'none'}}>
    //         <thead>
    //             <tr>
    //                 <th>S No.</th>
    //                 <th>Origin Name*</th>
    //                 <th>Origin District</th>
    //                 <th>Origin State*</th>
    //                 <th>Destination Name*</th>
    //                 <th>Destination District</th>
    //                 <th>Destination State*</th>
    //                 <th>Truck Type*</th>
    //                 <th>Distance (Km)</th>
    //                 <th>Transit Time (Days)</th>
    //                 <th>Annual Volume*</th>
    //                 <th>L1 Transporter Freight Rate*</th>
    //                 <th>L1 Transporter Name*</th>
    //                 <th>L1 Transporter Share of business (%)</th>
    //                 <th>L2 Transporter Freight Rate</th>
    //                 <th>L2 Transporter Name</th>
    //                 <th>L2 Transporter Share of business (%)</th>
    //             </tr>
    //         </thead>
    //     </table>
    // }

    const sampleFormat = (e) => {
        Activity([{ "screen": "My Freight Benchmark", "module": "My Freight Benchmark", "user_activity": "Sample template download button clicked", "timestamp": currentRequestTimeStamp(), "userEmail": userDetails?.email, "userName": userDetails?.user_name, companyname: userDetails.company_name ? userDetails.company_name : userDetails.email ? userDetails.email.split("@")[1].split(".")[0] : "" }])
        mixpanel.track(`User has clicked on format download button`, {
            ApplicationName: `${Urls.mixpanelappname}`,
            ScreenName: 'LoRRI-Benchmark',
            ModuleName: 'landing_page',
            ActivityLog: 'userClickedFormatDownloadButton',
            Data: `None`,
            Definition: `User has clicked on format download button`,
            ActivityType: 'event_view',
            UserName: userDetails?.user_name,
            UserEmail: userDetails?.email,
            CompanyName: userDetails.company_name
                ? userDetails.company_name
                : userDetails.email
                    ? userDetails.email.split("@")[1].split(".")[0]
                    : ""
        });
    }

    return (
        <center>
            <br />
            <div>
                {/* <DownloadExcelFormat/>
                <ReactHTMLTableToExcel
                    id="download-format-button"
                    className="btn btn-sm btn-link"
                    table="download_format"
                    filename="UploadFormat"
                    sheet="tablexls"
                    buttonText={<span style={{color: '#393185', fontSize: '14px', marginTop: '1%'}}><i className="fa fa-download" style={{ marginRight: '5px' }} />Please upload the lanes in the Standard Format</span>}
                /> */}

                <a className={`btn btn-link`}
                    href="https://lnclientdata.blob.core.windows.net/benchmark-uploads/UploadFormat.xlsx"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="format-download" style={{ color: '#393185', fontFamily: 'revert' }}
                    onClick={(e) => sampleFormat(e)}
                ><i className="fas fa-download" style={{ paddingRight: '4%' }}></i><span>Please upload the lanes in the Standard Format</span></a>
            </div>
            <div>
                <label className="btn btn-success upload-file-button-enquiry-my-account" style={{ marginTop: '3%' }}>
                    <input type="file" id="upload_file_button" onChange={e => uploadAttachments(e)} className="d-none" />
                    <i className="fas fa-upload mr-2"></i> <span style={{ marginLeft: '5px', color: 'white' }}>Upload File</span>
                </label>
            </div>
            <div style={{ display: 'flex', marginTop: '2%', marginBottom: '3%' }}>
                <input type="checkbox" disabled={true} style={{ width: '16px', marginLeft: '38%' }} />
                <span style={{ marginTop: '9px', marginLeft: '10px', fontSize: '16px' }}>Save in Freight Master</span>
            </div>
            <span style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
                Note : You will see the benchmark for lanes equivalent to the Remaining Lanes (Credits) in your account. To get more credits, please email (associate@logisticsnow.in) or call +91-9867773508 / +91-9653620207.
            </span>
            {showerrors && showerrors.length > 0 ?
                <div style={{ width: '70%', textAlign: 'left' }}>
                    <div style={{ fontSize: '16px', fontWeight: '600' }}>Errors:</div>
                    <div>
                        {showerrors.map((error) => {
                            return <div style={{ color: 'red' }}> {error}</div>
                        })}
                    </div>
                </div>
                : null}
        </center>
    )
}

export default UploadFile
